import "./DataTable.css";
import "./../../index.css";
import React from "react";
import { nameInitials } from "../../utils/helper";

const DataTable = (props) => {

    const { row, columns, showNameTumbnail, isScrollable, actionIcon, onActionClick } = props;
    // console.log("rows", row, columns, showNameTumbnail, isScrollable);
    
    const handleActionClick = (rowData, index) => {
        if (onActionClick) {
            onActionClick(rowData, index);
        }
    };
    
    return (
        <div className="table-container">
            <div className="scrollable-div" style={ isScrollable ? { height: "400px", overflowY: "scroll" } : {} }>
                <table>
                    <thead className={ isScrollable ? "scrollable-table-header" : "" }>
                        <tr>
                            {
                                row && row.length > 0  ? row.map((title, index) =>(
                                    <th key={ Math.random() + index } className="text-sm text-color">{ title }</th>
                                )) : null
                            }
                            { (actionIcon) && <th className="text-sm text-color">Action</th> }
                        </tr>
                    </thead>

                    <tbody>
                        {
                            columns.map((colData, parentIndex) => (
                                <tr key={ Math.random() + parentIndex }>
                                    {
                                        Object.entries(colData).map(([ key, value ], childIndex) =>(
                                            <td key={ Math.random() + childIndex } className="text-sm text-color">
                                                <div className="flex items-center">
                                                    { 
                                                        key == 'full_name' && showNameTumbnail && ( <div className="name-thumbnail mr-2" style={ { backgroundColor: `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}` } }>{ nameInitials(value) }</div> )
                                                    }

                                                    { value?.isTag ? (
                                                        <div className="tag" style={{ backgroundColor: value.color, minWidth: value.minWidth ? value.minWidth : "140px" }}>
                                                            {value.value}
                                                        </div>
                                                    ) : (
                                                        <div>{value?.value ?? value}</div>
                                                    )}
                                                </div>
                                            </td>
                                        ))
                                    }
                                    
                                    { (actionIcon) && (
                                        <td className="text-sm text-color">
                                            <div className="flex items-center cursor-pointer" onClick={() => handleActionClick(colData, parentIndex)}>

                                                { actionIcon && React.cloneElement(actionIcon, { style: { cursor: 'pointer' } }, { onClick: () => handleActionClick(colData, parentIndex) }) }

                                                {/* { actionButton && React.cloneElement(actionButton, ) } */}
                                            </div>
                                        </td>
                                    ) }
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default React.memo(DataTable);